import { useQuery } from '@tanstack/react-query';

import { useCore } from '../context/core.context';
import { StaticContentApiService } from '../../domain/static-content/static-content-api.service';
import { Locale } from '../../util/locales/locale.model';
import { getLocale } from '../../util/locales/locales';

export const useAppNews = (enabled = true) => {
  const {
    auth: { user },
  } = useCore();

  const locale = user?.locale ? new Locale(...(user.locale.split('-') as [string, string])) : getLocale();
  const { key, fetcher } = StaticContentApiService.getAppNewsFetcher(locale);

  return useQuery([key], fetcher, { enabled: enabled && !!user?.locale });
};
